import { ReactNode, useEffect, useState } from 'react';
import * as Slider from '@radix-ui/react-slider';
import { isNull } from 'lodash';
import { clamp } from '@radix-ui/number';
import { classNames } from '../../utils';

function convertValueToPercentage(value: number, min: number, max: number) {
  const maxSteps = max - min;
  const percentPerStep = 100 / maxSteps;
  const percentage = percentPerStep * (value - min);
  return clamp(percentage, [0, 100]);
}

export function RangeSlider({
  className,
  value,
  min,
  max,
  step,
  onChange,
  valueDisplay,
  sliderValueWrapperClassName,
  valueClassName,
  bottomText,
  bottomTextClassName,
  sliderClassName,
  disabled,
  marker,
  leftText,
  rightText,
}: {
  disabled?: boolean;
  className?: string;
  value: number[];
  max: number;
  step: number;
  min: number;
  onChange?: (value: number[]) => void;
  valueDisplay?: (value: number[], isDragging?: boolean) => ReactNode;
  bottomText?: (
    value: number | null | undefined,
    isDragging?: boolean
  ) => ReactNode;
  bottomTextClassName?: string;
  sliderValueWrapperClassName?: string;
  valueClassName?: string;
  sliderClassName?: string;
  marker?: number;
  isRangeValue?: boolean;
  leftText?: React.ReactNode;
  rightText?: React.ReactNode;
}) {
  const [currentDraggingValue, setCurrentDraggingValue] =
    useState<number[]>(value);
  const [isDragging, setIsDragging] = useState(false);

  // console.log('value =======>', {
  //   currentDraggingValue,
  //   isDragging,
  //   value,
  //   max,
  //   min,
  //   step,
  // });

  return (
    <div className={className}>
      <div
        className={classNames(
          'flex items-center justify-between gap-4',
          sliderValueWrapperClassName
        )}
      >
        <div className="flex w-full items-center">
          {leftText}
          <Slider.Root
            disabled={disabled}
            className={classNames(
              'relative flex h-5 w-full flex-[3] touch-none select-none items-center',
              sliderClassName
            )}
            defaultValue={value}
            value={isDragging ? currentDraggingValue : value}
            min={min}
            max={max}
            step={step}
            //@ts-ignore
            onValueChange={(e) => {
              setCurrentDraggingValue(e);
            }}
            onPointerDown={(e) => {
              setIsDragging(true);
              setCurrentDraggingValue(value);
            }}
            onPointerUp={() => {
              onChange?.(currentDraggingValue);
              setIsDragging(false);
            }}
          >
            <Slider.Track className="bg-hardwood-300 relative h-[2px] grow rounded-[2px]">
              <Slider.Range className="bg-morton-600 absolute h-full rounded-[2px]" />
            </Slider.Track>
            {typeof marker !== 'undefined' ? (
              <div
                className=" bg-morton-400 border-hardwood-30 absolute h-[8px] w-[8px] rounded-full border-[2px]"
                style={{
                  left: `calc(${convertValueToPercentage(
                    marker,
                    min,
                    max
                  )}% - ${3}px)`,
                }}
              ></div>
            ) : null}

            {value.map((_, i) => (
              <Slider.Thumb
                key={i}
                className={classNames(
                  'hover:bg-violet3 focus:shadow-blackA8 bg-morton-100 border-morton-600 block h-[16px] w-[16px] rounded-[16px] border-[2px] focus:outline-none',
                  isDragging ? 'cursor-grabbing' : 'cursor-grab'
                )}
              />
            ))}
          </Slider.Root>
          {rightText}
        </div>

        {valueDisplay ? (
          <div className={valueClassName}>
            {valueDisplay?.(currentDraggingValue, isDragging)}
          </div>
        ) : null}
      </div>
    </div>
  );
}
